import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { OptionValue } from 'ncoded-component-library/build/components/molecules/Select/Select.component';
import {
  COLUMNS,
  HEADING_TRANSLATIONS,
  SORTING_VALUES,
} from '../components/ActivityMetricsTable/data';
import {
  ASCENDING_DESCENDING_COPY,
  EARLIEST_LATEST_COPY,
  SORTING_ORDER,
  SortingDirectionValues,
} from 'models/Sort';

const MULTI_SORT_DIRECTION_COPY: Record<
  string,
  Record<string, string> | undefined
> = {
  dealCreatedAt: EARLIEST_LATEST_COPY,
  latestLeadAt: EARLIEST_LATEST_COPY,
  latestNoteAt: EARLIEST_LATEST_COPY,
  latestActivityAt: EARLIEST_LATEST_COPY,
  messageChannelsCount: ASCENDING_DESCENDING_COPY,
  filesCount: ASCENDING_DESCENDING_COPY,
};

const useActivityMetricsMultiSort = () => {
  const { t } = useTranslation();

  const sortColumns = useMemo(
    () => COLUMNS.filter((column) => !!SORTING_VALUES[column]),
    [],
  );

  const multiSortValues = useMemo(
    () =>
      sortColumns.map((column) => {
        const value = SORTING_VALUES[column];
        const label = t(HEADING_TRANSLATIONS[column]);

        return { value, label };
      }) as OptionValue<string>[],
    [sortColumns, t],
  );

  const multiSortDirectionTranslation = useMemo(() => {
    const result: SortingDirectionValues = {};

    for (const column of sortColumns) {
      const sort = SORTING_VALUES[column];
      const value = MULTI_SORT_DIRECTION_COPY[sort];

      result[sort] = {
        [SORTING_ORDER.A_TO_Z]: t(value?.[SORTING_ORDER.A_TO_Z] || 'aToZ'),
        [SORTING_ORDER.Z_TO_A]: t(value?.[SORTING_ORDER.Z_TO_A] || 'zToA'),
      };
    }

    return result;
  }, [sortColumns, t]);

  return { multiSortValues, multiSortDirectionTranslation };
};

export default useActivityMetricsMultiSort;
